import React from 'react';
import { ChevronLeft, Building2 } from 'lucide-react';
import C from '../../constants/colors';
import CompanyMapView from './CompanyMapView';

export default function CompanyScopeMapView({
  companyId, companies, sites, zones,
  employees, visitorCards, alerts, activeEvents,
  onBack, onSiteMapClick, onAcknowledge,
}) {
  const company = companies.find(c => c.id === companyId);
  const coSites = sites.filter(s => s.companyId === companyId);
  const siteIds = new Set(coSites.map(s => s.id));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <div style={{ padding: '12px 20px', borderBottom: `1px solid ${C.border}`, background: C.surface, flexShrink: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.textMuted, display: 'flex', alignItems: 'center', gap: '4px', padding: 0 }}>
          <ChevronLeft size={16} /><span style={{ fontSize: '13px' }}>All Sites</span>
        </button>
        <div style={{ width: '1px', height: '16px', background: C.border }} />
        <Building2 size={14} color={C.textSecondary} />
        <span style={{ fontSize: '14px', fontWeight: 700, color: C.textPrimary }}>{company?.name}</span>
        <span style={{ fontSize: '12px', color: C.textMuted }}>— {coSites.length} site{coSites.length !== 1 ? 's' : ''}</span>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <CompanyMapView
          companies={company ? [company] : []}
          sites={coSites}
          zones={zones.filter(z => siteIds.has(z.siteId))}
          employees={employees.filter(e => e.companyId === companyId)}
          visitorCards={visitorCards.filter(vc => siteIds.has(vc.siteId))}
          alerts={alerts.filter(a => a.companyId === companyId)}
          activeEvents={activeEvents}
          onSiteClick={onSiteMapClick}
          onAcknowledge={onAcknowledge}
        />
      </div>
    </div>
  );
}
